module.exports = __webpack_public_path__ + "img/icon-geocoding-1501253f.svg";